import { gql } from "graphql-tag";

export const GET_ANALYTICS_DEDUCTIONS_BY_PURCHASER = gql`
  query AnalyticsDeductionsByPurchaser($params: GetAnalyticsInput!) {
    analyticsDeductionsByPurchaser(params: $params) {
      purchaser {
        purchaserId
        purchaserKey
        purchaserName
      }
      amount
      share
      count
    }
  }
`;
